module.exports = __webpack_public_path__ + "static/media/12D.dca63d8b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/12D.svg
// module id = 42
// module chunks = 0